import { apiClient, loginApiClient } from "../config/api.config";

export interface SetPasswordWithTempPayload {
  email: string;
  temporaryPassword: string;
  newPassword: string;
}

export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}

/**
 * Set password with temporary password (Public - No Auth Required)
 * POST /api/v1/account/set-password-with-temp
 */
export function setPasswordWithTemp(data: SetPasswordWithTempPayload) {
  return loginApiClient.request({
    method: "post",
    url: "/account/set-password-with-temp",
    data,
  });
}

/**
 * Change password (Auth Required)
 * POST /api/v1/account/change-password
 */
export function changePassword(data: ChangePasswordPayload) {
  return apiClient.request({
    method: "post",
    url: "/account/change-password",
    data,
  });
}

